const stringHelper = {
	isBlank: (str) => {
		return (!str || /^\s*$/.test(str));
	},
	isEmpty: (str) => {
		return (!str || 0 === str.length);
	},
	isEmail: (email) => {
		var emailPattern = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
		return emailPattern.test(email);
	},
    resolverIconeAtendente: (nome)=>{
      const [primeiro, segundo] = nome.split(' ');
      return `${primeiro[0] ?? ""}${segundo?.length | false ? segundo[0] : ""}`
    },
    normalizar: (string)=>{
      return string
            .normalize("NFD")                      // separa letras dos acentos
            .replace(/[\u0300-\u036f]/g, "")       // remove acentos
            .replace(/[^a-zA-Z0-9 ]/g, "")         // remove caracteres especiais
            .toLowerCase();  
    },
    htmlToText(html) {
      const div = document.createElement('div');
      div.innerHTML = html;

      div.querySelectorAll('br').forEach(br => br.replaceWith('\n'));

      return div.innerText
        .replace(/\n\s+\n/g, '\n')
        .trim();
    }
};
export default stringHelper;
